import script from "./SearchResultsList.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchResultsList.vue?vue&type=script&setup=true&lang=js"

import "./SearchResultsList.vue?vue&type=style&index=0&id=f463ada2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f463ada2"]])

export default __exports__